import { render, staticRenderFns } from "./TeacherReports.vue?vue&type=template&id=f92fbf16&lang=en&"
import script from "./TeacherReports.vue?vue&type=script&lang=js&"
export * from "./TeacherReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports